<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div class="data-satu-inspection-text-tab" :class="{ 'form-disabled': disabled }">
    <div class="row">
      <!-- Data Satu (FORM02: data_satu_inspection_text.cat_emcr_inalum_datas) -- baris = baris tabel Plant (`rows_from`). -->
      <div v-if="isTableVisible(DATA_SATU_TAB, INALUM_DATAS_FIELD)" :class="showInspectionTexts ? 'col-md-6' : 'col-12'">
        <div class="card h-100">
          <div class="card-header py-3 pb-2" style="padding-left: 1rem">
            <h6 class="mb-0 fw-semibold">INALUM Data</h6>
            <small class="text-muted">Rows follow the Plant table in the Plant &amp; Storage Location tab.</small>
          </div>
          <div class="card-body pt-0 px-0 card-body-tab">
            <DataTable :value="dialog.form[INALUM_DATAS_FIELD] || []" class="p-datatable-sm p-datatable-gridlines" scrollable scroll-height="420px">
              <template v-for="col in DATA_SATU_COLUMNS" :key="col.column">
                <Column v-if="isColumnVisibleFn(col.column, INALUM_DATAS_FIELD, DATA_SATU_TAB)" header-class="bg-light text-center" :style="columnWidth(col.width)">
                  <template #header>
                    {{ col.label }} <span v-if="isColumnMandatoryInRows(DATA_SATU_TAB, INALUM_DATAS_FIELD, col.column)" class="exclamation-mark-error-tab">*</span>
                  </template>
                  <template #body="{ data }">
                    <!-- Plant: penanda baris (diisi dari tabel Plant), cuma ditampilkan. -->
                    <SelectPrime show-clear v-if="col.type === 'select'" v-model="data[col.column]" size="small" fluid disabled
                      :options="dialog.options[columnOptionsKey(DATA_SATU_TAB, INALUM_DATAS_FIELD, col.column, data)]"
                      option-label="label" option-value="value" :placeholder="col.label"
                    >
                      <template #value="{ value, placeholder }">
                        <span v-if="value != null && value !== ''">{{ getSelectValueLabelFn(dialog.options[columnOptionsKey(DATA_SATU_TAB, INALUM_DATAS_FIELD, col.column, data)], value) }}</span>
                        <span v-else>{{ placeholder }}</span>
                      </template>
                    </SelectPrime>
                    <!-- Select yang bisa dipilih user, opsi dari data_source kolom di config (loadColumnOptions). Kolom tanpa
                         data_source (mis. UNSPSC X Ref., master-nya belum ada) -> daftar opsi kosong. -->
                    <SelectPrime show-clear v-else-if="col.type === 'dropdown'" v-model="data[col.column]" size="small" fluid filter
                      :options="dialog.options[columnOptionsKey(DATA_SATU_TAB, INALUM_DATAS_FIELD, col.column, data)] || []"
                      option-label="label" option-value="value" :placeholder="col.label"
                      :loading="!!dialog.loading[columnOptionsKey(DATA_SATU_TAB, INALUM_DATAS_FIELD, col.column, data)]"
                      :invalid="isColumnInvalidFn(data, col.column)"
                      :disabled="disabled || !isColumnEnabledFn(col.column, INALUM_DATAS_FIELD, DATA_SATU_TAB)"
                      @show="loadColumnOptions(DATA_SATU_TAB, INALUM_DATAS_FIELD, col.column, data)"
                    >
                      <template #value="{ value, placeholder }">
                        <span v-if="value != null && value !== ''">{{ getSelectValueLabelFn(dialog.options[columnOptionsKey(DATA_SATU_TAB, INALUM_DATAS_FIELD, col.column, data)], value) }}</span>
                        <span v-else>{{ placeholder }}</span>
                      </template>
                    </SelectPrime>
                    <!-- Category Item: pilih banyak, opsi dari data_source config; disimpan array kategori yang dipilih (kolom json).
                         Nilai dari DB (array / string JSON) dibaca checkedValues -> opsinya langsung tercentang. -->
                    <MultiSelect v-else-if="col.type === 'multiselect'" :model-value="checkedValues(data[col.column])" size="small" fluid
                      :options="staticColumnOptions(DATA_SATU_TAB, INALUM_DATAS_FIELD, col.column)"
                      option-label="label" option-value="value" :placeholder="col.label" display="chip" show-clear
                      :invalid="isColumnInvalidFn(data, col.column)"
                      :disabled="disabled || !isColumnEnabledFn(col.column, INALUM_DATAS_FIELD, DATA_SATU_TAB)"
                      @update:model-value="data[col.column] = $event || []"
                    />
                    <!-- Checkbox tunggal: dicentang = "X", tidak dicentang = null (sama dengan Co Product / Post To QI Stock). -->
                    <div v-else-if="col.type === 'checkbox'" class="text-center">
                      <Checkbox v-model="data[col.column]" :binary="true" true-value="X" :false-value="null"
                        :disabled="disabled || !isColumnEnabledFn(col.column, INALUM_DATAS_FIELD, DATA_SATU_TAB)"
                      />
                    </div>
                    <Calendar v-else-if="col.type === 'date'" :model-value="toDateValue(data[col.column])" show-icon date-format="dd/mm/yy" placeholder="DD/MM/YYYY" fluid
                      :invalid="isColumnInvalidFn(data, col.column)"
                      :disabled="disabled || !isColumnEnabledFn(col.column, INALUM_DATAS_FIELD, DATA_SATU_TAB)"
                      @update:model-value="data[col.column] = fromDateValue($event, col.dateStore)"
                    />
                    <InputText v-else v-model="data[col.column]" size="small" :placeholder="col.label" fluid
                      :invalid="isColumnInvalidFn(data, col.column)"
                      :disabled="disabled || !isColumnEnabledFn(col.column, INALUM_DATAS_FIELD, DATA_SATU_TAB)"
                    />
                  </template>
                </Column>
              </template>
              <template #empty>
                <div class="text-muted text-center small py-3">No plant yet. Add a plant in the Plant &amp; Storage Location tab.</div>
              </template>
            </DataTable>
          </div>
        </div>
      </div>

      <!-- Inspection Text (FORM02: data_satu_inspection_text.cat_emcr_inspection_texts) -->
      <div v-if="showInspectionTexts" class="col-md-6">
        <div class="card h-100">
          <div class="card-header py-3 pb-2 d-flex align-items-center justify-content-between" style="padding-left: 1rem">
            <h6 class="mb-0 fw-semibold">
              Inspection Text <span v-if="isTableMandatory(DATA_SATU_TAB, INSPECTION_TEXTS_FIELD)" class="exclamation-mark-error-tab">*</span>
            </h6>
            <ButtonPrime v-if="canAddRow(DATA_SATU_TAB, INSPECTION_TEXTS_FIELD)" icon="pi pi-plus" label="Add" size="small" :disabled="disabled" @click="addRow(DATA_SATU_TAB, INSPECTION_TEXTS_FIELD)" />
          </div>
          <div class="card-body pt-0 px-0 card-body-tab">
            <DataTable :value="dialog.form[INSPECTION_TEXTS_FIELD] || []" class="p-datatable-sm p-datatable-gridlines" scrollable scroll-height="420px">
              <Column v-if="isColumnVisibleFn('language', INSPECTION_TEXTS_FIELD, DATA_SATU_TAB)" header-class="bg-light text-center" :style="columnWidth(180)">
                <template #header>
                  Language <span v-if="isColumnMandatoryInRows(DATA_SATU_TAB, INSPECTION_TEXTS_FIELD, 'language')" class="exclamation-mark-error-tab">*</span>
                </template>
                <template #body="{ data }">
                  <SelectPrime show-clear v-model="data.language" size="small" fluid
                    :options="dialog.options[columnOptionsKey(DATA_SATU_TAB, INSPECTION_TEXTS_FIELD, 'language', data)]"
                    option-label="label" option-value="value" placeholder="Select Language"
                    :invalid="isColumnInvalidFn(data, 'language')"
                    :disabled="disabled || !isColumnEnabledFn('language', INSPECTION_TEXTS_FIELD, DATA_SATU_TAB)"
                    @show="loadColumnOptions(DATA_SATU_TAB, INSPECTION_TEXTS_FIELD, 'language', data)"
                    @change="onColumnChange(DATA_SATU_TAB, INSPECTION_TEXTS_FIELD, 'language', data)"
                  >
                    <template #value="{ value, placeholder }">
                      <span v-if="value != null && value !== ''">{{ getSelectValueLabelFn(dialog.options[columnOptionsKey(DATA_SATU_TAB, INSPECTION_TEXTS_FIELD, 'language', data)], value) }}</span>
                      <span v-else>{{ placeholder }}</span>
                    </template>
                  </SelectPrime>
                </template>
              </Column>
              <Column v-if="isColumnVisibleFn('inspection_text', INSPECTION_TEXTS_FIELD, DATA_SATU_TAB)" header-class="bg-light text-center" style="min-width: 400px">
                <template #header>
                  Inspection Text <span v-if="isColumnMandatoryInRows(DATA_SATU_TAB, INSPECTION_TEXTS_FIELD, 'inspection_text')" class="exclamation-mark-error-tab">*</span>
                </template>
                <template #body="{ data }">
                  <PrimeTextarea v-model="data.inspection_text" rows="3" auto-resize placeholder="Inspection Text" fluid
                    :invalid="isColumnInvalidFn(data, 'inspection_text')"
                    :disabled="disabled || !isColumnEnabledFn('inspection_text', INSPECTION_TEXTS_FIELD, DATA_SATU_TAB)"
                  />
                </template>
              </Column>
              <Column v-if="canRemoveRow(DATA_SATU_TAB, INSPECTION_TEXTS_FIELD)" header-class="bg-light text-center" style="width: 56px">
                <template #header>Action</template>
                <template #body="{ index }">
                  <ButtonPrime icon="pi pi-trash" severity="danger" text size="small" :disabled="disabled" @click="removeRow(INSPECTION_TEXTS_FIELD, index)" />
                </template>
              </Column>
              <template #empty>
                <div class="text-muted text-center small py-3">No inspection text yet.</div>
              </template>
            </DataTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formConfigHelper from "@/helpers/New_formConfig";
import { cataloguerTabMixin, useCataloguerTabEngine, createTabDialog } from "./New_CataloguerTab";

// Key tab & field repeatable di FORM02_BASE.json
const DATA_SATU_TAB = "data_satu_inspection_text";
const INALUM_DATAS_FIELD = "cat_emcr_inalum_datas";
const INSPECTION_TEXTS_FIELD = "cat_emcr_inspection_texts";

// Layout kolom Data Satu (urutan, label, jenis input) -- hardcode di Vue sesuai prinsip "layout hardcode, behavior dynamic".
// Tampil/wajib/opsi dari config FORM02. Review Date disimpan "dd/mm/yyyy 00:00:00" (format kolom di DB & data integrasi).
// UNSPSC X Ref. & Remark = checkbox "X" / null.
const DATA_SATU_COLUMNS = [
  { column: "plant", label: "Plant", type: "select", width: 150 },
  { column: "category_item", label: "Category Item", type: "multiselect", width: 350 },
  { column: "unspsc_x_reference", label: "UNSPSC X Ref.", type: "dropdown", width: 200 },
  { column: "mind_id_number", label: "Mind ID Number", type: "text", width: 170 },
  { column: "review_date_inalum_data", label: "Review Date", type: "date", width: 180, dateStore: "dmy_time" },
  { column: "remark_inalum_data", label: "Remark", type: "text", width: 220 }
];

// Props, setup engine, dialog, bind ke mcrItem, addRow/removeRow/opsi kolom: kerangka bersama New_CataloguerTab.js.
export default {
  name: "DataSatuInspectionTextTab",
  mixins: [cataloguerTabMixin],
  setup(props) {
    return useCataloguerTabEngine(props);
  },
  data() {
    return {
      DATA_SATU_TAB,
      INALUM_DATAS_FIELD,
      INSPECTION_TEXTS_FIELD,
      DATA_SATU_COLUMNS,
      dialog: createTabDialog(this.mcrItem)
    };
  },
  computed: {
    // Tidak tampil -> tabel Data Satu melebar penuh (col-12).
    showInspectionTexts() {
      return this.isTableVisible(DATA_SATU_TAB, INSPECTION_TEXTS_FIELD);
    }
  },
  methods: {
    columnWidth(width) {
      return { width: `${width}px`, minWidth: `${width}px` };
    },
    // Opsi statis kolom (data_source type "array") untuk MultiSelect -- tanpa request, opsi langsung dari config.
    staticColumnOptions(tab, field, column) {
      const options = formConfigHelper.getColumnConfig(this.formConfig, tab, field, column)?.data_source?.options || [];
      return options.map((item) => ({ value: item.code, label: item.label || item.description || item.code }));
    },
    // Nilai kolom multiselect dari DB bisa array, string JSON, atau string JSON ter-encode dua kali (data lama) -> array.
    checkedValues(value) {
      let current = value;
      for (let i = 0; typeof current === "string" && i < 3; i += 1) {
        try {
          current = JSON.parse(current);
        } catch {
          return current.trim() ? [current.trim()] : [];
        }
      }
      return Array.isArray(current) ? current : [];
    },
    // Hook kerangka bersama, dipanggil tiap item dipilih/berganti. cat_emcr_inalum_datas sudah di-link ke cat_emcr_plants
    // oleh New_CataloguerForm.hydrateItem (rows_from) -- ensureTableArrays melewatinya.
    onItemBound() {
      this.ensureTableArrays(DATA_SATU_TAB);
      this.preloadTabLabels(DATA_SATU_TAB);
    }
  }
};
</script>
